<template>
  <div class="leco-content">
    <div class="page-title">アクセスログ</div>
    <div v-show="mainLoading" class="loader">loading...</div>
    <transition>
      <div v-show="!mainLoading">
        <div class="clearfix"></div>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          max-height="85vh"
          :fixed-header="true"
          :search-options="{
            enabled: true
          }"
        >
        </vue-good-table>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import jQuery from "jquery";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import Vue from "vue";
import { API_BASE_URL } from "@/common/config";
Vue.use(VueGoodTablePlugin);

global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

export default {
  name: "wish-list",

  data() {
    return {
      columns: [
        {
          label: "ID",
          field: "id"
        },
        {
          label: "アクセス日時",
          field: "access_date"
        },
        {
          label: "ユーザー名",
          field: "user_name"
        },
        {
          label: "参照ページ",
          field: "referer"
        },
        {
          label: "ブラウザ（User-Agent）",
          field: "user_agent"
        },
        {
          label: "source_ip",
          field: "source_ip"
        }
      ],
      rows: [],
      mainLoading: false,
      logger: this.$store.state.logger
    };
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.mainLoading = true;
    //アクセスログを取得
    this.logger.info("アクセスログを取得");
    let api_url = API_BASE_URL + "access-logs";
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((response) => {
        //statusCode==200以外は全部500のエラー画面に飛ばす
        if ("statusCode" in response.data) {
          if (response.data.statusCode == 200) {
            this.rows = response.data.body;
            this.logger.info("アクセスログの読み込み終了。");
            this.logger.debug(JSON.stringify(response.data));
          } else {
            this.$router.push("/system-error500");
          }
        } else {
          this.$router.push("/system-error500");
        }
        this.mainLoading = false;
      })
      .catch((error) => {
        this.mainLoading = false;
        this.logger.error("アクセスログの読み込みに失敗");
        this.logger.error(error);
        this.$router.push("/system-error500");
      });
  }
};
</script>

<style scoped>
.vgt-table > tbody > tr > td > span > a {
  color: var(--leco-link-color);
}

.top-message-wrapper {
  /* 凡例を下寄せにするために必要 */
  height: 48px;
  position: relative;
}

.table-hanrei {
  /* 凡例を下寄せ */
  position: absolute;
  bottom: 8px;
}

.create-training-master-button {
  margin-bottom: 8px;
}

@media screen and (max-width: 600px) {
  .top-message-wrapper {
    /* モバイル時は余白調整を無効にする */
    position: initial;
  }

  .table-hanrei {
    font-size: 75%;
  }
}

/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
